import Vue from "vue";
import Vuex from "vuex";

import main from "./modules/store";


Vue.use(Vuex);

const store = function () {
	const s = new Vuex.Store({
		state: {},
		modules: {main},
		actions: {}
	});

	return s;
};

export default store;
